import { render, staticRenderFns } from "./SubTabButtons.vue?vue&type=template&id=008be200&"
import script from "./SubTabButtons.vue?vue&type=script&lang=js&"
export * from "./SubTabButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports